import { Injectable } from '@angular/core';
import { map, Observable } from "rxjs";
import { BulkChangeData, BulkSearchResult } from "@models/ui-models/bulk-change-data";
import { Address } from '../../../models/address/address';
import { transformBulkSearchData } from "../utils/transform-bulk-search-data.util";
import BaseApiService from "../../../shared/services/base/base-api.service";

@Injectable({
  providedIn: 'root'
})
export class BulkChangesApiService extends BaseApiService {
  searchByName(name: string): Observable<BulkChangeData[]> {
    const url = name
      ? `${ this.apiUrl }/bulk/search-by-name?name=${ name }`
      : `${ this.apiUrl }/bulk/search-by-name?name=null`;

    return this.api.get<BulkSearchResult>(url)
      .pipe(
        map(transformBulkSearchData)
      );
  }

  bulkSearchByAddressAndQuery(address: Address | null, query: string, countryCode: string | null, entityIds: string[] = []): Observable<BulkSearchResult> {
    const queries = query.split(";").map(item => item.trim());
    const body = {
      address: address,
      queries: queries,
      countryCode: countryCode,
      entityIds: entityIds
    };
    const options = {
      headers: { 'Content-Type': 'application/json' }
    };

    return this.api.post<BulkSearchResult>(`${ this.apiUrl }/bulk/search-by-address`, body, options);
  }

  searchByAddressAndQuery(address: Address | null, query: string, countryCode: string, entityIds: string[] = []): Observable<BulkChangeData[]> {
    return this.bulkSearchByAddressAndQuery(address, query, countryCode, entityIds)
      .pipe(
        map(transformBulkSearchData)
      );
  }
}
